/** @format */

import apiSlice from './api-slice';

export const bookingRequestApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createBookingRequest: builder.mutation({
      query: (params) => ({
        url: '/booking/request',
        method: 'POST',
        body: params
      }),
      invalidatesTags: ['BookingRequest']
    }),
    confirmBookingRequest: builder.mutation({
      query: ({ id, ...params }) => ({
        url: `/booking/request/${id}/confirm`,
        method: 'PATCH',
        body: params
      }),
      invalidatesTags: ['BookingRequest']
    }),
    assignBookingRequest: builder.mutation({
      query: ({ id, ...params }) => ({
        url: `/booking/request/${id}/assign`,
        method: 'PATCH',
        body: params
      }),
      invalidatesTags: ['BookingRequest']
    }),

    retractBookingRequest: builder.mutation({
      query: ({ id, ...params }) => {
        return {
          url: `/booking/request/${id}/retract`,
          method: 'PATCH',
          body: params
        };
      },
      invalidatesTags: ['BookingRequest']
    }),
    getBookingRequestByUser: builder.query({
      query: ({ id, ...params }) => ({
        url: `/booking/request/byUser/${id}`,
        method: 'GET',
        params: params
      }),
      providesTags: ['BookingRequest']
    }),
    getBookingRequestByCondition: builder.query({
      query: ({ conditionId, ...params }) => ({
        url: `/booking/request/byCondition/${conditionId}`,
        method: 'GET',
        params: params
      }),
      providesTags: ['BookingRequest']
    })
  })
});

export const {
  useCreateBookingRequestMutation,
  useConfirmBookingRequestMutation,
  useAssignBookingRequestMutation,
  useRetractBookingRequestMutation,
  useGetBookingRequestByUserQuery,
  useLazyGetBookingRequestByUserQuery,
  useLazyGetBookingRequestByConditionQuery
} = bookingRequestApi;
